import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW6001Component } from './kymw6001.component';
import { GetCwsPlanGoodsUseImageGroupDispListService } from './api-services/get-cws-plan-goods-use-image-group-disp-list.service';
import { GetCwsPlanGoodsUseImageGroupListService } from './api-services/get-cws-plan-goods-use-image-group-list.service';
import { UpdateCheckStatusService } from './api-services/update-check-status.service';
import { GetImageGroupInfoService } from 'src/app/commons/kymw0c/kymw0c00/api-services/get-image-group-info.service';
import { CwsPlanGoodsUseImageGrioupListService } from '../kymw6000/list-service/cwsPlanGoodsUseImageGroupList.service';


/**
 * EC使用画像一覧表画面 モジュール設定クラス
 *
 * @export KYMW6001Module
 * @class KYMW6001Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW6001Component,
  ],
  providers: [
    UpdateCheckStatusService,
    GetCwsPlanGoodsUseImageGroupListService,
    GetCwsPlanGoodsUseImageGroupDispListService,
    GetImageGroupInfoService,
    CwsPlanGoodsUseImageGrioupListService,
  ],
})
export class KYMW6001Module {

}
